import { useState, useEffect } from 'react';

function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');

        // Atualiza o Consent Mode para "granted" ao aceitar
        try {
            if (window.gtag) {
                window.gtag('consent', 'update', {
                    ad_storage: 'granted',
                    analytics_storage: 'granted',
                    ad_user_data: 'granted',
                    ad_personalization: 'granted'
                });
            }
        } catch (e) {
            // opcional: silenciar erros
        }

        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            backgroundColor: '#323232',
            color: 'white',
            padding: '10px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 1000
        }}>
      <span>
        Este site usa cookies para melhorar a experiência do usuário.
      </span>
            <button
                onClick={handleAccept}
                style={{
                    backgroundColor: '#4caf50',
                    border: 'none',
                    color: 'white',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                Ok, entendi
            </button>
        </div>
    );
}

export default CookieConsent;